import type { Category } from '@/interface/category';

import type { MenuSnapshotProduct } from '../types/menu-snapshot';

export function getProductsByCategory(products: MenuSnapshotProduct[], categoryId: string): MenuSnapshotProduct[] {
  return products.filter(product => product.product_category?.some(pc => pc.category_id === categoryId));
}

export function sortCategories(categories: Category[]): Category[] {
  return [...categories].sort((a, b) => {
    const priorityDiff = (a.priority ?? 0) - (b.priority ?? 0);
    if (priorityDiff !== 0) return priorityDiff;
    return a.name.localeCompare(b.name, 'es');
  });
}

export function productHasSubselections(product: MenuSnapshotProduct): boolean {
  if (!product.product_subselection || product.product_subselection.length === 0) return false;

  return product.product_subselection.some(ps => {
    return (
      ps.subselection?.subselection_item?.some(item => {
        return (item as any).product_stock?.stock !== 0;
      }) ?? false
    );
  });
}
